<template>
    <div class="col-12 col-md-3 col-lg-2 saas-message-sidebar">
        <nav class="admin-message-tabs" :aria-label="trans('message.message')">
            <ul class="admin-message-tabs__list">
                <li>
                    <router-link
                        to="/message/compose"
                        class="admin-message-tabs__link"
                        :class="{ 'admin-message-tabs__link--active': menu === 'compose' }"
                    >
                        <admin-icon name="send" aria-hidden="true"></admin-icon>
                        <span>{{ trans('message.compose') }}</span>
                    </router-link>
                </li>
                <li>
                    <router-link
                        to="/message/draft"
                        class="admin-message-tabs__link"
                        :class="{ 'admin-message-tabs__link--active': menu === 'draft' }"
                    >
                        <admin-icon name="pencil" aria-hidden="true"></admin-icon>
                        <span>{{ trans('message.draft') }}</span>
                        <span class="admin-message-tabs__count" v-if="statistics && statistics.draft">({{ statistics.draft }})</span>
                    </router-link>
                </li>
                <li>
                    <router-link
                        to="/message/inbox"
                        class="admin-message-tabs__link"
                        :class="{ 'admin-message-tabs__link--active': menu === 'inbox' }"
                    >
                        <admin-icon name="inbox" aria-hidden="true"></admin-icon>
                        <span>{{ trans('message.inbox') }}</span>
                        <span class="admin-message-tabs__count" v-if="statistics && statistics.inbox">({{ statistics.inbox }})</span>
                    </router-link>
                </li>
                <li>
                    <router-link
                        to="/message/sent"
                        class="admin-message-tabs__link"
                        :class="{ 'admin-message-tabs__link--active': menu === 'sent' }"
                    >
                        <admin-icon name="share" aria-hidden="true"></admin-icon>
                        <span>{{ trans('message.sent_box') }}</span>
                        <span class="admin-message-tabs__count" v-if="statistics && statistics.sent">({{ statistics.sent }})</span>
                    </router-link>
                </li>
                <li>
                    <router-link
                        to="/message/important"
                        class="admin-message-tabs__link"
                        :class="{ 'admin-message-tabs__link--active': menu === 'important' }"
                    >
                        <admin-icon name="star" aria-hidden="true"></admin-icon>
                        <span>{{ trans('message.important') }}</span>
                    </router-link>
                </li>
                <li>
                    <router-link
                        to="/message/trash"
                        class="admin-message-tabs__link"
                        :class="{ 'admin-message-tabs__link--active': menu === 'trash' }"
                    >
                        <admin-icon name="trash" aria-hidden="true"></admin-icon>
                        <span>{{ trans('message.trash') }}</span>
                        <span class="admin-message-tabs__count" v-if="statistics && statistics.trash">({{ statistics.trash }})</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        props: {
            menu: {
                default: ''
            },
            statistics: {

            }
        },
        mounted(){
        }
    }
</script>

<style scoped>
.saas-message-sidebar {
    background: #f8fafc !important;
    border-right: 1px solid #e6e9ef;
}

.admin-message-tabs__list {
    gap: 0.2rem;
}

.admin-message-tabs__link {
    border: 0;
    border-radius: 6px;
    color: #64748b !important;
    font-weight: 600;
}

.admin-message-tabs__link:hover {
    background: #ffffff;
    color: #0f172a !important;
    box-shadow: none;
}

.admin-message-tabs__link .icon {
    color: #206bc4;
}

.admin-message-tabs__link--active {
    border-color: transparent;
    background: #e8f1fb !important;
    color: #206bc4 !important;
    box-shadow: none !important;
}

.admin-message-tabs__link--active .icon {
    color: #206bc4;
}

.admin-message-tabs__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.35rem;
    height: 1.2rem;
    padding: 0 0.35rem;
    border-radius: 999px;
    border: 0;
    background: #e8f1fb;
    color: #206bc4;
    font-weight: 700;
    opacity: 1;
}

.admin-message-tabs__link--active .admin-message-tabs__count {
    border-color: transparent;
    background: #206bc4;
    color: #ffffff;
}
</style>
